<div class="graph-buttons-list">
  <!-- <div>
      <label>Time Frame:</label>
      <mat-button-toggle-group class="graph-buttons" (change)="timePeriodSelected($event);" [(ngModel)]="graphData.Timeperiod" appearance="legacy" name="timePeriod" aria-label="Time Frame">
        <mat-button-toggle value="2">Last 24h</mat-button-toggle>
        <mat-button-toggle value="3">Last 7 Days</mat-button-toggle>
        <mat-button-toggle value="4">Last Month</mat-button-toggle>
        <mat-button-toggle value="null">Custom</mat-button-toggle>
      </mat-button-toggle-group>
      <mat-button-toggle-group (change)="timeFrameSelected($event);" [(ngModel)]="graphData.TimeFrame" appearance="legacy" name="timeFrame" aria-label="Time Frame">
        <mat-button-toggle value="Hour">Hourly</mat-button-toggle>
        <mat-button-toggle value="Day">Daily</mat-button-toggle>
        <mat-button-toggle value="Week">Weekly</mat-button-toggle>
        <mat-button-toggle value="Month">Monthly</mat-button-toggle>
      </mat-button-toggle-group>
  </div> -->

  @if (showTimeFilter) {
<tools-time-frame-selector class="pull-left"
    [selectedInterval]="graphData.Interval"
    [selectedTimeFrame]="graphData.TimeFrame"
    [selectedTimePeriod]="graphData.Timeperiod"
    (intervalChanged)="intervalInputChanged($event)"
    (timeFrameChanged)="timeFrameSelected($event)"
    (timePeriodChanged)="timePeriodSelected($event)"
   
  ></tools-time-frame-selector>
}
  <!-- <div class="inline-datepickers"> -->
  @if (showDatepickerToggle) {
<div style="max-width: 20%;">
    <section class="example-section">
      <mat-label>Single Day</mat-label>
      <mat-slide-toggle class="example-margin" (change)="toggleDatepicker($event)" [checked]="this.graphData.Variables['dayFilter']"></mat-slide-toggle>
      <mat-label>Date Range</mat-label>
    </section>
  </div>
}
  @if (showDaterangeSelector) {
<div [hidden]="graphData.Timeperiod != null" class="customDates" style="min-width: 80%;">
    <tools-date-range-picker
      [id]="statusDates"
      #statusDates
      [startDateHeading]="'Start date'"
      [endDateHeading]="'End date'"
      [defaultStartDate]="graphData.StartDate"
      [defaultEndDate]="graphData.EndDate"
      [calendarMonthStart]="false"
      (notify)='updateDates($event)'
      [inline]="true" >
    </tools-date-range-picker>
  </div>
}
  @if (showDaySelector) {
<div [hidden]="graphData.Timeperiod != null" style="width: 100%;">
    <tools-date-time
    [showTimePicker]="false"
    [providedDate]="graphData.StartDate.toISOString()"
    (notify)="dayPickerChanged($event)"
    ></tools-date-time>
  </div>
}
  <!-- </div> -->
  <div class="extra-tools">
    @if (showTableViewToggle) {
<mat-slide-toggle
       
        style="vertical-align: middle"
        color="warn"
        [(ngModel)]="tableViewChecked"
        (change)="viewChanged()">
        Table View
    </mat-slide-toggle>
}
  @if (showRefresh) {
<button mat-raised-button style="margin-left: 20px" (click)="emitToParent();"><i class="material-icons">refresh</i></button>
}
</div>
</div>
@if (showTimeFilter) {
<div >
  @if (TimeFilters && TimeFilters.length > 0) {
<tools-searchable-combobox
      #times
      class="fieldSelect"
     
      [isRequired]="true"
      [multipleAllowed]="false"
      [comboboxHeading]="'Select a time filter'"
      [comboboxPlaceholderName]="'Find a time filter'"
      [unFilteredOptions]="TimeFilters"
      [preSelected]="[selectedInterval]"
      (notify)='updateSelectedTimeFilter($event)'>
  </tools-searchable-combobox>
}
</div>
}
<!--<div class="graph-area" *ngIf="!tableViewChecked">-->
  @if (!noData && !graphData.IsMulti) {
<div class="single-graph">
    <app-generic-graph [isTableView]="tableViewChecked" [enableDataLabels]="enableDataLabels" [height]="height" #GraphChild (selected)="notify($event)" [enableDataPoints]="enableDataPoints"></app-generic-graph>
  </div>
}
  @if (!noData && graphData.IsMulti) {
<div class="graph-grid">
    @for (item of graphNames; track item) {
<div class="graph-cell">
      <h2>{{ item }}</h2>
      <app-generic-graph [isTableView]="tableViewChecked"  [enableDataLabels]="enableDataLabels" [height]="height" #GraphChildren [enableDataPoints]="enableDataPoints"></app-generic-graph>
    </div>
}
  </div>
}
@if (noData) {
<div>
    <br/>
    <br/>
    No results were found
</div>
}
